import React from 'react';
import './WorkSection.css';

const workProjects = [
    {
        title: 'Godzilla in Lagos AI Film',
        description: 'When a colossal force awakens beneath the city, chaos erupts across Lagos. As the monster rises, a battle for survival unfolds—where humanity faces its biggest threat yet. Epic. Unstoppable. Godzilla.',
        embedUrl: 'https://www.youtube.com/embed/WTBObPGYL9s'
    },
    {
        title: 'Mirrored Opposites AI Film',
        description: 'After men and women divide to live on separate worlds, a boy and a girl dare to cross the boundaries of hatred. From two broken societies, they risk everything—and fall in love.',
        embedUrl: 'https://www.youtube.com/embed/7QsCd_cd7MU'
    },
    {
        title: 'Crimson Bondage AI Film',
        description: 'Bound by blood, driven by vengeance. In a world of secrets and betrayal, one warrior must confront the darkness within—and the crimson ties that refuse to break.',
        embedUrl: 'https://www.youtube.com/embed/5MwUln6yvp8'
    },
    {
        title: 'AI MOVIE TRAILER',
        description: 'A psychological movie trailer involving surreal environments that pushes the human imagination to the limit.',
        embedUrl: 'https://www.youtube.com/embed/UdsTyGC968Q'
    },
    {
        title: 'AI DRAGON MOVIE TRAILER',
        description: 'An attempt to remake the hit HBO series, House of the Dragon.',
        embedUrl: 'https://www.youtube.com/embed/Tj0G0urFa_M'
    }
];

const WorkSection = () => {
    return (
        <section id="work" className="work-section">
            <h2 className="section-title">AI FILMS</h2>
            <div className="work-grid">
                {workProjects.map((work, index) => (
                    <div key={index} className="work-card">
                        {work.embedUrl ? (
                            <div className="youtube-embed">
                                <iframe
                                    src={work.embedUrl}
                                    title={work.title}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        ) : (
                            <video src={work.videoUrl} controls muted className="work-video" />
                        )}
                        <h3>{work.title}</h3>
                        <p>{work.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default WorkSection;
